import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { SLocation, SMarker, STheme, SThread, SView } from 'servisofts-component2';
import { SMapView } from 'servisofts-component2-smap';
import MDL from '../../MDL';
import * as HERE from '@here/flexpolyline';

import MapStyles from './MapStyles';
import { useIsFocused } from '@react-navigation/native';

import SSocket from 'servisofts-socket';
import IconMap from "../../Assets/svg/iconMap.svg"
import { enableScreens } from 'react-native-screens';
enableScreens(false); // deshabilita desmontaje de pantallas

const Mapa_ = (props) => {
    const isFocused = useIsFocused();

    if (!isFocused) return null; // oculta el mapa mientras la pantalla no está activa

    return <Mapa {...props}/>
}
export default Mapa_;
Mapa_.INSTANCE = null;
class Mapa extends Component {
// export default class Mapa extends Component {
    // static INSTANCE: Mapa;
    map: SMapView;
    constructor(props) {
        super(props);
        // Quiero iniciar en espanha
        this.state = {
            initialRegion: {
                latitude: 39.416775,
                longitude: -3.703790,
                latitudeDelta: 11.922,
                longitudeDelta: 11.9421
            },
            expediciones: MDL.sigestran.expediciones,
            active: MDL.backgroundLocation.active,
            mapReady: false
        };
        this.mounted = false;
        Mapa_.INSTANCE = this;
    }
    // shouldComponentUpdate() {
    //     return false;
    // }
    statuschange() {
        // const pedido = this.state.pedido;

        // if (pedido) {
        //     if (pedido.state == "esperando_conductor") {
        //         this.map.getUserLocation().then(e => {
        //             this.map.fitToCoordinates([{
        //                 latitude: e.latitude,
        //                 longitude: e.longitude
        //             }, {
        //                 latitude: pedido.restaurante.latitude,
        //                 longitude: pedido.restaurante.longitude
        //             }], {
        //                 edgePadding: {
        //                     top: 50,
        //                     right: 50,
        //                     bottom: 350,
        //                     left: 50
        //                 }
        //             })
        //         })
        //         return;
        //     }
        //     if (pedido.state == "entregado_conductor" || pedido.state == "conductor_llego") {
        //         this.map.getUserLocation().then(e => {
        //             this.map.fitToCoordinates([{
        //                 latitude: e.latitude,
        //                 longitude: e.longitude
        //             }, {
        //                 latitude: pedido.restaurante.latitude,
        //                 longitude: pedido.restaurante.longitude
        //             }, {
        //                 latitude: pedido.direccion.latitude,
        //                 longitude: pedido.direccion.longitude
        //             }], {
        //                 edgePadding: {
        //                     top: 50,
        //                     right: 50,
        //                     bottom: 350,
        //                     left: 50
        //                 }
        //             })
        //         })
        //         return;
        //     }
        // }
        if (!this.map) return;
        if (!MDL.backgroundLocation?.active) {
            this.map.animateToRegion({ ...this.state.initialRegion }, 1000)
        } else {
            // SLocation.getCurrentPosition().then(e => {
            this.map.getUserLocation().then(e => {
                if (!MDL.backgroundLocation.active) return;
                if (this?.map?.animateToRegion)
                    this.map.animateToRegion({
                        latitude: e.latitude,
                        longitude: e.longitude,
                        latitudeDelta: 0.01,
                        longitudeDelta: 0.01
                    }, 1000)
            }).catch(e => {
                console.error(e)
            })
        }
    }
    componentDidMount() {
        this.mounted = true;
        Mapa_.INSTANCE = this;
        // this.statuschange()
        this.listener1 = MDL.backgroundLocation.addEventListener("changeStatus", (active) => {
            if (this.mounted) {
                this.setState({ active: MDL.backgroundLocation.active })
                this.statuschange()
            }
        })

        this.onChangeExpedicionesListener = MDL.sigestran.addEventListener("changeExpediciones", (e) => {
            if (this.mounted) {
                this.setState({ expediciones: e.expediciones });
            }
        })

    }


    componentWillUnmount() {
        this.mounted = false;
        Mapa_.INSTANCE = null;
        MDL.backgroundLocation.removeEventListener(this.listener1)
        MDL.sigestran.removeEventListener(this.onChangeExpedicionesListener);
        // MDL.pedido.removeEventListener(this.listemer2)
    }

    getPoints() {
        const points = []
        if (!this.state.expediciones || !Array.isArray(this.state.expediciones)) {
            return points;
        }
        
        this.state.expediciones.map(expedicion => {
            if (expedicion?.origen && Array.isArray(expedicion.origen)) {
                expedicion.origen.map((origen, index) => {
                    const lat = parseFloat(origen?.dLatitud ?? "0");
                    const lng = parseFloat(origen?.dLongitud ?? "0");
                    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
                        points.push({
                            latitude: lat,
                            longitude: lng,
                            fill: STheme.colorFromText(expedicion.lExpedicionReal_id + "" + expedicion.sOrigen),
                            children: <SView style={{ width: 16, height: 16, borderRadius: 20, backgroundColor: STheme.colorFromText(expedicion.lExpedicionReal_id + "" + expedicion.sOrigen) }} />
                        });
                    }
                })
            }
            if (expedicion?.destinos && Array.isArray(expedicion.destinos)) {
                expedicion.destinos.map((destino, index) => {
                    const lat = parseFloat(destino?.dLatitud ?? "0");
                    const lng = parseFloat(destino?.dLongitud ?? "0");
                    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
                        points.push({
                            latitude: lat,
                            longitude: lng,
                            children: <IconMap height={25} fill={STheme.color.secondary} />,
                            fill: STheme.colorFromText(expedicion.lExpedicionReal_id + "" + expedicion.sDestino),
                        });
                    }
                })
            }
        })
        return points;
    }

    renderMarkerExpediciones() {
        const points = this.getPoints();
        if (!points || points.length == 0) return null;
        return points.map((point, index) => {
            if (!point || typeof point.latitude !== 'number' || typeof point.longitude !== 'number') {
                return null;
            }
            return <SMapView.SMarker
                key={`marker-${index}`}
                ref={e => this.marker = e}
                {...point} >
                {/* <IconMap height={25} fill={STheme.color.secondary} /> */}
                {point.children}
            </SMapView.SMarker>
        })
    }

    renderRoutes() {
        if (!this.mounted || !this.state.mapReady) {
            return null;
        }
        
        const routes = []
        if (!this.state.expediciones || !Array.isArray(this.state.expediciones)) {
            return null;
        }
        
        this.state.expediciones.map(expedicion => {
            if (expedicion?.situaciondb?.rutas) {
                expedicion.situaciondb.rutas.map((ruta, index) => {
                    if (ruta?.here?.routes?.[0]?.sections?.[0]?.polyline) {
                        try {
                            const route = ruta.here.routes[0]
                            const respHere = HERE.decode(route.sections[0].polyline);
                            
                            if (respHere?.polyline && Array.isArray(respHere.polyline) && respHere.polyline.length > 1) {
                                const arrauPointsPolyline = respHere.polyline.map(a => {
                                    return {
                                        latitude: a[0],
                                        longitude: a[1]
                                    }
                                })
                                
                                if (arrauPointsPolyline.length > 1) {
                                    routes.push(< SMapView.SPolyline
                                        key={`route-${expedicion.lExpedicionReal_id}-${index}`}
                                        coordinates={arrauPointsPolyline}
                                        strokeWidth={2}
                                        // strokeColor={STheme.colorFromText((ruta.sTipo ?? "Ruta") + expedicion.sDestino)} />
                                        strokeColor={STheme.colorFromText(expedicion.lExpedicionReal_id + "" + expedicion.sOrigen)} />
                                    )
                                }
                            }
                        } catch (error) {
                            console.error("Error rendering route:", error);
                        }
                    }

                })
            }

        })
        return routes;
    }
    handlePressMap(route) {
        console.log("handlePressMap", route);
        return;
        MDL.backgroundLocation.testSend({
            key_usuario: MDL.usuario.session.lChofer_id,
            plate: MDL.usuario.session.plate,
            latitude: route.coordinate.latitude,
            longitude: route.coordinate.longitude,
        })
    }
    render() {
        Mapa_.INSTANCE = this;
        if (!MDL.usuario.session) return null;
        return <SMapView
            ref={ref => this.map = ref}
            initialRegion={this.state.initialRegion}
            renderToHardwareTextureAndroid={true}
            showsUserLocation={this.state.active}
            customMapStyle={(!this.state.active ? MapStyles.darkDisabled : MapStyles.darkEnabled)}
            liteMode={false}
            onPress={this.handlePressMap.bind(this)}
            onMapReady={() => {
                if (this.mounted) {
                    this.setState({ mapReady: true });
                }
            }}
        >
            {this.renderMarkerExpediciones()}
            {this.renderRoutes()}
        </SMapView>
    }
}